import { ApiError } from './httpClient'
import type { ImageUploadDto } from '../dto/shared/ImageDto'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api'

/**
 * Uploads a single image file and returns the relative URL it's reachable at afterwards
 * (GET /api/images/{key} - see ImageController.kt). Separate from httpClient.request because
 * that one always sends Content-Type: application/json, which would break the multipart
 * boundary a FormData body needs.
 */
async function upload(file: File): Promise<ImageUploadDto> {
  const formData = new FormData()
  formData.append('file', file)

  let response: Response
  try {
    response = await fetch(`${API_BASE_URL}/images`, { method: 'POST', body: formData })
  } catch {
    throw new ApiError(0, 'Backend nicht erreichbar. Läuft der Server?', { path: '/images' })
  }

  if (!response.ok) {
    throw new ApiError(response.status, `Bild-Upload fehlgeschlagen mit Status ${response.status}`, {
      path: '/images',
    })
  }
  return (await response.json()) as ImageUploadDto
}

export const imageApi = { upload }
